import { cachedAPIWrapper } from "../apiCaching/apiWrapper";
import { apiConfig } from "../config/apiConfig";
import { apiCaching } from "../config/cachingConfig";
import { keyGenerator } from "../util/keyGeneration";
import { updateVDomElement, VNode } from "../util/virtualDom";
import TestimonialCommon, { TESTIMONIAL_SELECTOR } from "./testimonial-common";

export class TestimonialRocket{
    private static instance: TestimonialRocket | null;
    private pageNumber: number;
    private readonly pageSize: number;
    private conceptId: any = null;
    private countryId: any = null;
    private weblocationId: string = "";
    private selectedStarRating: number;
    private popoverElement: HTMLElement | null = null;
    private upArrow: HTMLElement | null = null;
    private downArrow: HTMLElement | null = null;
    private resetLink: HTMLElement | null = null;
    private overAllRatings: string;
    private skeletonElement: HTMLElement | null = null;
    private contentElement: HTMLElement | null = null;
    private readonly selector: string = TESTIMONIAL_SELECTOR;
    private testimonialsSection: HTMLElement | null = null;
    private noReviewSection: HTMLElement | null = null;
    private realUl: HTMLElement | null = null;
    private skeletonUl: HTMLElement | null = null;
    private ratingCache: { [key: number]: any } = {}; // Cache for storing rating data
    private ratingText: HTMLElement | null = null;
    private ratingsInfo: HTMLElement | null = null;
    private starsDisplay: HTMLElement | null = null;
    private starRatingDrpdwn: HTMLElement | null = null;
    private ratingForm: HTMLElement | null = null;
    private wrapperElement: HTMLElement | null = null;
    private seeMoreButton: HTMLElement | null = null;
    private resetClickHandler?: EventListener;
    private starRatingDropdownHandler?: EventListener;
    private starsDisplayHandler?: EventListener;
    private seeMoreClickHandler?: EventListener;

    static getTestimonialInstance(): TestimonialRocket {
        TestimonialRocket.instance??= new TestimonialRocket();
        return TestimonialRocket.instance;
    }

    constructor(){
        this.pageNumber = 1; // Initial page number
        this.pageSize = window.innerWidth >= 768 ? 30 : 4; // Number of items per page
        this.selectedStarRating = 5;
        this.overAllRatings = '5/5';
        this.showRatingSkeleton();
    }

    domLookup(){
        this.conceptId = (document.getElementById("conceptId") as HTMLInputElement)?.value ?? '';
        this.resetLink = document.getElementById('resetLink');
        this.upArrow = document.getElementById('upArrow');
        this.downArrow = document.getElementById('downArrow');
        this.popoverElement = document.getElementById('popover');
        this.skeletonElement = document.getElementById('ratingskeleton');
        this.contentElement = document.getElementById('ratingcontent');
        this.testimonialsSection = document.querySelector(this.selector);
        this.noReviewSection = document.querySelector('.no-review-section');
        this.realUl = document.getElementById('realtestimonials');
        this.skeletonUl = document.getElementById('testimonialskeletons');
        this.ratingText = document.getElementById('ratingText');
        this.ratingsInfo = document.getElementById('ratingsInfo');
        this.starsDisplay = document.getElementById('starsDisplay');
        this.starRatingDrpdwn = document.getElementById('popoverBtn');
        this.ratingForm = document.getElementById("ratingForm");
        this.wrapperElement = document.querySelector('.testimonials-section .container');
        
        this.weblocationId = (document.getElementById('weblocationId') as HTMLInputElement)?.value ?? localStorage.getItem("franchiseWebLocationId") ?? '';
        if (sessionStorage.getItem('countryCode') != null) {
            const storedCode = sessionStorage.getItem('countryCode')?.toLowerCase();
            if (storedCode === "us") {
                this.countryId = "1";
            } else {
                this.countryId = "2";
            }
        } else {
            const countryCode =  (document.getElementById("countryCode") as HTMLInputElement)?.value;
            if (countryCode) {
                if (countryCode?.toLowerCase() === "us") {
                    this.countryId = "1";
                } else {
                    this.countryId = "2";
                }
            } else {
                this.countryId = "1";
            }
        }
        this.setCSSStyling();
        this.handleClickEvents();
        this.constructSeeMoreButton();
        if (this.resetLink) {
            this.resetClickHandler = () => this.onResetClick();
            this.resetLink.addEventListener('click', this.resetClickHandler);
        }
    }

    setCSSStyling(){
        if(this.starsDisplay){
            this.starsDisplay.style.cursor = "pointer";
        }
        if(this.resetLink){
            this.resetLink.style.visibility = "hidden";
            this.resetLink.classList.remove("hidden");
            this.resetLink.classList.add("reset-text");
        }
    }

    constructSeeMoreButton(){
        if(!this.wrapperElement){
            return;
        }
        const btn = `
        <div class="testi-btn-wrapper">                
            <a href="#" class="primary-btn"> See More...</a>                
        </div>`
        this.wrapperElement?.insertAdjacentHTML('beforeend', btn);
        this.seeMoreButton = document.querySelector('.testi-btn-wrapper .primary-btn');
        if(this.seeMoreButton){
            this.seeMoreClickHandler = (e: Event) => { void this.seeMoreData(e); };
            this.seeMoreButton.addEventListener('click', this.seeMoreClickHandler);
        }
    }

    handleClickEvents(){
        if (this.starRatingDrpdwn) {
            this.starRatingDropdownHandler = () => this.handleDropdownToggle();
            this.starRatingDrpdwn.addEventListener('click', this.starRatingDropdownHandler);
        }
    }

    protected onResetClick() {
        if(this.resetLink)
            this.resetLink.style.visibility = "hidden";
        this.toggleTestimonialsUl(false);
        this.updateStarsDisplay(5);
        if (this.ratingForm) {
            const radioButtons = this.ratingForm.querySelectorAll('input[name="rating"]');
            // Add a change event listener to each radio button
            radioButtons?.forEach((radio) => {
                const inputRadio = radio as HTMLInputElement;
                inputRadio.checked = false;
            });
        }
        const realUl = this.realUl;
        if (realUl) {
            realUl.innerHTML = '';
        }
        this.popoverElement?.classList?.toggle("hidden");
        this.selectedStarRating = 5;
        this.pageNumber = 1;
        this.getData(false);
    }

    protected handleDropdownToggle() {
        if (this.popoverElement) {
            this.showHideRatingDrpDwn()
            this.handleStarRatingFilter();
        }
    }

    protected showHideRatingDrpDwn() {
        this.popoverElement?.classList?.toggle("hidden");
        this.upArrow?.classList?.toggle("hidden");
        this.downArrow?.classList?.toggle("hidden");
    }
    
    protected hideShowMoreButton(){
        if(this.seeMoreButton){
            this.seeMoreButton.classList.add("hidden");
        }
    }

    protected showShowMoreButton(){
        if(this.seeMoreButton){
            this.seeMoreButton.classList.remove("hidden");
        }
    }

    protected handleStarRatingFilter() {
        if (this.ratingForm) {
            const ratingForm = this.ratingForm;
            const radioButtons = ratingForm.querySelectorAll('input[name="rating"]');
            // Add a change event listener to each radio button
            radioButtons?.forEach((radioButton) => {
                (radioButton as HTMLInputElement).onclick = () => {
                    this.toggleTestimonialsUl(false);
                    const selectedRadio = ratingForm.querySelector('input[name="rating"]:checked') as HTMLInputElement;
                    if (selectedRadio) {
                        const realUl = this.realUl;
                        if (realUl) {
                            realUl.innerHTML = '';
                        }
                        this.selectedStarRating = parseInt(selectedRadio.value, 10);
                        this.pageNumber = 1;
                        const initialLoad = false;
                        this.getData(initialLoad);
                        this.showHideRatingDrpDwn();
                        this.updateStarsDisplay(this.selectedStarRating);
                        this.handleRatingDisplayChanges();
                    }
                }
            });
        }
    }

    protected updateStarsDisplay(rating: number) {
        const starsContainer = this.starsDisplay;
        if (starsContainer) {
            starsContainer.innerHTML = "";
            for (let i = 0; i < 5; i++) {
                const starElement = document.createElement("span");
                if(i < rating){
                    starElement.className = "star full";
                }else{
                    starElement.className = "star";
                }
                starElement.innerHTML = '&#9733;';
                starsContainer.appendChild(starElement);
            }
        }
    }

    protected handleRatingDisplayChanges() {
        if(this.resetLink){
            this.resetLink.style.visibility = "visible";
        }
    }

    async getData(initialLoad: boolean = true){
        
        const url = `${apiConfig.TESTIMONIAL_REVIEWS}/${this.conceptId}/${this.weblocationId || 0}/${this.countryId}/0/1/${this.pageSize}/${this.selectedStarRating}`;
        const cacheKey = keyGenerator(url, this.selector);
        let  cachedData = await this.getFromCache(cacheKey);
        const wasCacheHit = Array.isArray(cachedData) && cachedData.length > 0;

        if(!wasCacheHit){
            cachedData = await this.getDataFromServer(this.selectedStarRating);
        }
        if (!Array.isArray(cachedData) || cachedData.length === 0) {
            this.showNoReviewSection();
        }
        else{
            this.hideNoReviewSection();
            this.showRatingContent();
            
            const lists = await this.createTestimonialLists(cachedData);
            const testimonialListNode: VNode = {
                type: 'ul',
                props: {},
                children: lists,
            };
            if (this.realUl) {
                updateVDomElement(this.realUl, testimonialListNode);
            }
            this.showOverallRatings(cachedData);
            this.toggleTestimonialsUl();
            if (!wasCacheHit) {
                await this.storeInCache(cacheKey, cachedData);
            }
        }
        
        let ratings = [5, 4, 3, 2, 1];
        if(!initialLoad){
            ratings = [this.selectedStarRating];
        }
        this.showShowMoreButton();
        this.silentCalls(ratings);
    }

    showOverallRatings(data : any){
        if(!data.length){
            return;
        }
        let storedOverallRating;
        let storedGrandTotal;
        if(data[0]?.overallRating && data[0]?.grandTotal){
            storedOverallRating = data[0]?.overallRating;
            storedGrandTotal = data[0]?.grandTotal;
            const obj = {
                "or" : storedOverallRating,
                "gt" : storedGrandTotal
            }
            sessionStorage.setItem(`rev-${this.weblocationId}`, JSON.stringify(obj));
        }
        else{
            const revObj = JSON.parse(sessionStorage.getItem(`rev-${this.weblocationId}`) || "{}");
            storedOverallRating = revObj?.or;
            storedGrandTotal = revObj?.gt;
        }
        if(!storedOverallRating || !storedGrandTotal){
            const url = apiConfig.TESTIMONIAL_REVIEWS + `/${this.conceptId}/${this.weblocationId || 0}/${this.countryId}/0/1/1/5`;
            cachedAPIWrapper(url, apiCaching.TestimonyAndReview).then((data) => {
                if(data.length){
                    storedOverallRating = data[0]?.overallRating;
                    storedGrandTotal = data[0]?.grandTotal;
                    const obj = {
                        "or" : storedOverallRating,
                        "gt" : storedGrandTotal
                    }
                    sessionStorage.setItem(`rev-${this.weblocationId}`, JSON.stringify(obj));
                }
            }).catch((error) => {
                console.error("Error fetching data:", error);
                if(this.ratingText && this.ratingsInfo){
                    this.ratingText.classList.add("hidden");
                    this.ratingsInfo.classList.add("hidden");
                }
            });
        }
        if (this.ratingText && this.ratingsInfo) {
            this.overAllRatings = `${storedOverallRating}/5`;
            this.ratingText.textContent = this.overAllRatings;
            const totalReviews = this.ratingsInfo.querySelector("p");
            if (totalReviews) {
                totalReviews.textContent = `${storedGrandTotal} Ratings`;

            }
        }
    }

    async silentCalls(ratings : number[]){
        const currentStarRating =  this.selectedStarRating;
        const isPrefetchOfSinglePage = ratings.length === 1;
        await Promise.allSettled(
            ratings.map(async (rating) => {
                try {
                    const pageNumber = rating === currentStarRating ? (this.pageNumber + 1) : this.pageNumber;
                    const url = `${apiConfig.TESTIMONIAL_REVIEWS}/${this.conceptId}/${this.weblocationId || 0}/${this.countryId}/0/${pageNumber}/${this.pageSize}/${rating}`;
                    const cacheKey = keyGenerator(url, this.selector);

                    // Try cache first
                    let cachedData = await this.getFromCache(cacheKey);
                    const hasUsableCache = Array.isArray(cachedData) && cachedData.length > 0;
                    if (!hasUsableCache) {
                        // Fetch and then cache
                        const data = await this.getDataFromServer(rating);
                        if (Array.isArray(data) && data.length) {
                            await this.storeInCache(cacheKey, data);
                            this.ratingCache[rating] = data;
                        }
                        else if(!data.length && isPrefetchOfSinglePage){
                            this.hideShowMoreButton();
                        }
                    } else {
                        // Populate in-memory cache from IDB
                        this.ratingCache[rating] = cachedData;
                    }
                    
                } catch (e) {
                    console.warn('Testimonial init failed; will allow retry.', e);
                }
            })
        );
    }


    //Load more data
    protected async seeMoreData(event: any) {
        event.preventDefault();
        this.pageNumber++; 
        const selectedRating = this.selectedStarRating ? this.selectedStarRating : 5;
        try {
            const url = `${apiConfig.TESTIMONIAL_REVIEWS}/${this.conceptId}/${this.weblocationId || 0}/${this.countryId}/0/${this.pageNumber}/${this.pageSize}/${selectedRating}`;
            const cacheKey = keyGenerator(url, this.selector);
            let  cachedData = await this.getFromCache(cacheKey);
            const wasCacheHit = Array.isArray(cachedData) && cachedData.length > 0;

            if(!wasCacheHit){
                cachedData = await this.getDataFromServer(this.selectedStarRating);
            }
            if (!Array.isArray(cachedData) || cachedData.length === 0) {
                this.showNoReviewSection();
            }
            else{
                this.hideNoReviewSection();
                this.showRatingContent();
                
                const lists = await this.createTestimonialLists(cachedData);
                const testimonialListNode: VNode = {
                    type: 'ul',
                    props: {},
                    children: lists,
                };
                if (this.realUl) {
                    updateVDomElement(this.realUl, testimonialListNode);
                }
                this.showOverallRatings(cachedData);
                this.toggleTestimonialsUl();
                if (!wasCacheHit) {
                    await this.storeInCache(cacheKey, cachedData);
                }
            }
            this.silentCalls([this.selectedStarRating]);
        } catch (error) {
            console.error('Error loading more testimonials:', error);
            this.showNoReviewSection();
        }
        

    }

    protected getDataFromServer(rating: number, pageNumber?: number) {
        const common = TestimonialCommon.getInstance();
        const pageNumber1 = pageNumber ?? this.pageNumber;
        return common.getDataFromServer(
            this.conceptId,
            this.weblocationId || 0,
            this.countryId,
            pageNumber1,
            this.pageSize,
            rating
        );
    }

    protected showRatingSkeleton() {
        if (this.skeletonElement) this.skeletonElement.classList?.remove('hidden');
        if (this.contentElement) this.contentElement.classList?.add('is-hidden');
    }

    protected showRatingContent() {
        if (this.skeletonElement) this.skeletonElement.classList?.add('hidden');
        if (this.contentElement) this.contentElement.classList?.remove('is-hidden');
        if (this.realUl) this.realUl.classList?.remove('hidden');
    }

    protected showNoReviewSection() {
        if(this.testimonialsSection) this.testimonialsSection?.classList.add('hidden');
        if(this.noReviewSection) this.noReviewSection?.classList.remove("hidden");
    }

    protected hideNoReviewSection() {
        if(this.testimonialsSection) this.testimonialsSection?.classList.remove('hidden');
        if(this.noReviewSection) this.noReviewSection?.classList.add("hidden");
    }

    protected toggleTestimonialsUl(showTestimonials: boolean = true) {
        if(showTestimonials){
            if (this.skeletonUl) this.skeletonUl.classList?.add('hidden');
            if (this.realUl) this.realUl.classList?.remove('hidden');
        }
        else{
            if (this.skeletonUl) this.skeletonUl.classList?.remove('hidden');
            if (this.realUl) this.realUl.classList?.add('hidden');
        }
    }

    public generateRatingStars(rating: number): string {
        return TestimonialCommon.getInstance().generateRatingStars(rating);
    }

    public createTestimonialVNode(data: any): VNode | null {
        return TestimonialCommon.getInstance().createTestimonialVNode(data);
    }

    private async storeInCache(key: string, data: any): Promise<void> {
        return TestimonialCommon.getInstance().storeInCache(key, data);
    }

    private async getFromCache(key: string): Promise<any> {
        return TestimonialCommon.getInstance().getFromCache(
            key,
            this.selectedStarRating,
            this.ratingCache
        );
    }
    private async handleCacheFailure() {
        return TestimonialCommon.getInstance().handleCacheFailure(this.ratingCache);
    }
    private async createTestimonialLists(result: any[]): Promise<VNode[]> {
        return TestimonialCommon.getInstance().createTestimonialLists(result);
    }

    public destroy(): void {
        // Remove event listeners
        if (this.resetLink && this.resetClickHandler) {
            this.resetLink.removeEventListener('click', this.resetClickHandler);
        }
        if (this.starRatingDrpdwn && this.starRatingDropdownHandler) {
            this.starRatingDrpdwn.removeEventListener('click', this.starRatingDropdownHandler);
        }
        if (this.starsDisplay && this.starsDisplayHandler) {
            this.starsDisplay.removeEventListener('click', this.starsDisplayHandler);
        }
        if (this.seeMoreButton && this.seeMoreClickHandler) {
            this.seeMoreButton.removeEventListener('click', this.seeMoreClickHandler);
        }

        // Remove dynamically inserted elements
        const btnWrapper = document.querySelector('.testi-btn-wrapper');
        if (btnWrapper?.parentElement) {
            btnWrapper.parentElement.removeChild(btnWrapper);
        }

        // Clear DOM references to help GC
        this.popoverElement = null;
        this.upArrow = null;
        this.downArrow = null;
        this.resetLink = null;
        this.skeletonElement = null;
        this.contentElement = null;
        this.testimonialsSection = null;
        this.noReviewSection = null;
        this.realUl = null;
        this.skeletonUl = null;
        this.ratingText = null;
        this.ratingsInfo = null;
        this.starsDisplay = null;
        this.starRatingDrpdwn = null;
        this.ratingForm = null;
        this.wrapperElement = null;
        this.seeMoreButton = null;

        // Clear in-memory caches and lightweight state
        this.ratingCache = {};

        // Null out handler references
        this.resetClickHandler = undefined;
        this.starRatingDropdownHandler = undefined;
        this.starsDisplayHandler = undefined;
        this.seeMoreClickHandler = undefined;
    }

    public static destroyInstance(): void {
        if (TestimonialRocket.instance) {
            TestimonialRocket.instance.destroy();
            TestimonialRocket.instance = null;
        }
    }
}
